export default {
  title: {
    companyManagement: '公司管理',
    roleManagement: '角色管理',
    companyAdd: '增添公司',
    companyEdit: '编辑公司'
  },
  menu: '公司管理',
  label: {
    name: '英文名',
    cnName: '中文名',
    company: '公司',
    country: '国家 / 地区',
    province: '省 / 州',
    city: '城市 / 城镇',
    companyEnglishName: '公司英文名称',
    companyChineseName: '公司中文名称',
    parentCompany: '上属公司',
    option: '操作',
    companyName: '公司名称',
    addCompany: '添加公司',
    editCompany: '编辑公司'
  },
  placeholder: {
    country: '请选择国家 / 地区',
    province: '请选择省 / 州',
    city: '请选择城市 / 城镇',
    companyEnglishName: '请输入公司英文名称',
    companyChineseName: '请输入公司中文名称',
    parentCompany: '请选择上属公司'
  },
  btn: {
    addCompany: '添加公司'
  },
  message: {
    parentCompanyError: '不能设置上属公司为此公司的下属公司',
    optionSuccess: '操作成功',
    optionField: '操作失败',
    deleteConfirm: '是否要删除该公司 {companyName} ?',
    companyRequired: '这是必填项。'
  }
}
